import { render, staticRenderFns } from "./SurveyClient.vue?vue&type=template&id=3bf532e0&scoped=true&"
import script from "./SurveyClient.vue?vue&type=script&lang=js&"
export * from "./SurveyClient.vue?vue&type=script&lang=js&"
import style0 from "./SurveyClient.vue?vue&type=style&index=0&id=3bf532e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf532e0",
  null
  
)

export default component.exports